import React from 'react';
import { Modal, Typography, List } from 'antd';
import styled from 'styled-components';
import { COLORS, TEXT_SIZES } from '../../../utils/constants';
import { CloseCircleOutlined } from '@ant-design/icons';
import Button from '../../common/Button';

interface DeleteFacilityModalProps {
  visible: boolean;
  facilityName?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteFacilityModal: React.FC<DeleteFacilityModalProps> = ({
  visible,
  facilityName,
  onCancel,
  onConfirm,
}) => {
  return (
    <StyledModal
      title="Delete Facility"
      open={visible}
      width={635}
      onCancel={onCancel}
      centered
      closeIcon={
        <CloseCircleOutlined
          style={{ color: COLORS.white.primary, fontSize: TEXT_SIZES.XXL }}
        />
      }
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="delete" type="primary" danger onClick={onConfirm}>
          Delete Facility
        </Button>,
      ]}
    >
      <ContentWrapper>
        <WarningText>
          Are you sure you want to permanently delete{' '}
          {facilityName && <strong>{facilityName}</strong>}?
        </WarningText>
        <SubText>This action cannot be undone.</SubText>
      </ContentWrapper>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-content {
    overflow: hidden;
    padding: 0px;
  }
  .ant-modal-header {
    background: ${COLORS.red.primary};
    margin-bottom: 24px;
    padding: 16px 24px;
  }
  .ant-modal-title {
    color: ${COLORS.white.primary} !important;
    font-size: ${TEXT_SIZES.LG};
  }
  .ant-modal-footer {
    padding: 16px 24px;
  }
`;

const ContentWrapper = styled.div`
  padding: 0 24px;
`;

const WarningText = styled(Typography.Text)`
  display: block;
  font-size: ${TEXT_SIZES.MD};
  margin-bottom: 8px;
`;

const SubText = styled(Typography.Text)`
  display: block;
  margin-bottom: 24px;
`;

export default DeleteFacilityModal;
